export default "__VITE_ASSET__DX12BtvO__"